import styled from "@emotion/styled";
import { FC } from "react";

import { ErrorFilled, OpenInNew } from "@livechat/design-system-icons";
import { Icon, Tag } from "@livechat/design-system-react-components";

import { BadgeKind } from "constants/settings/interfaces";

import { newBadgeStyles } from "./styles";

export const OnOffBadge: FC<{ active: boolean }> = ({ active }) =>
  active ? (
    <StyledTag kind="success" size="small">
      ON
    </StyledTag>
  ) : (
    <StyledTag kind="default" size="small">
      OFF
    </StyledTag>
  );

export const ExternalBadge: FC = () => <Icon source={OpenInNew} kind="primary" size="small" />;
export const ErrorBadge: FC = () => <Icon source={ErrorFilled} kind="error" size="medium" />;

export const NewFeatureBadge: FC = () => <div css={newBadgeStyles}>NEW!</div>;

export const Badge: FC<{ kind?: BadgeKind }> = ({ kind }) => {
  switch (kind) {
    case BadgeKind.On:
      return <OnOffBadge active />;
    case BadgeKind.Off:
      return <OnOffBadge active={false} />;
    case BadgeKind.External:
      return <ExternalBadge />;
    case BadgeKind.Error:
      return <ErrorBadge />;
    default:
      return null;
  }
};

const StyledTag = styled(Tag)`
  flex-shrink: 0;
`;
